import React, { useState } from "react";
import OperationDischarge from "./OperationDischarge";
import DocumentObverseCapture from "./DocumentObverseCapture";
import DocumentVerification from "./DocumentVerificationForm";
import { OperationRecomendation } from "./OperationRecomendation/OperationRecomendation";
import LegalTerms from "./LegalTerms/LegalTerms";
import ProfessionalActivityDropdown from "./ProfesionalActivityDropdown";
import PublicOfficeDropdown from "./PublicOfficeDropdown";
import PurchasePurposeDropdown from "./PurchasePurposeDropdown";
import Signature from "./Signature";
import { Box, Typography } from "@mui/material";
import ScanDocumentComponent from "./ScanDocumentComponent";
import FinishOperation from "./FinishOperation";
import DocumentReverseCapture from "./DocumentReverseCapture";
import logoHeader from "assets/logoHeader.svg";
import { useGetACompanyQuery } from "redux/api/companyApi";
import { RootState, useAppSelector } from "redux/store";
import { IUserLoggedState } from "redux/features/loggedUserSlice";
import { useDispatch, useSelector } from "react-redux";
import { addStep, removeLastStep, resetStep, setStep } from "redux/features/stepperSlice";

const IMAGE_SERVER = process.env.REACT_APP_IMAGES_ENDPOINT;

const StepperForm = () => {
  const { user } = useAppSelector(
    (state: { userLoggedState: IUserLoggedState }) => state.userLoggedState
  );
  const {
    data: company,
    error,
    isLoading,
  } = useGetACompanyQuery(user?.companyId as string, {
    skip: !user?.companyId,
  });
  const dispatch = useDispatch();
  const currentStep = useSelector((state: RootState) => state.stepper.currentStep);


  const handleNextStep = (stepIncrement?: number) => {
    const increment = stepIncrement ?? 1; // Usa el valor pasado o 1 como predeterminado
    const nextStep = currentStep + increment;
    dispatch(addStep(nextStep));
  };
  const handlePreviousStep = () => {
    dispatch(removeLastStep()); // Elimina el último paso de la lista
    
  };
  const handleFinalStep = () => {
    dispatch(setStep(12));

  }
  const handleReset = () => {
    dispatch(resetStep());
  };

  const isLocalhost = (IMAGE_SERVER ?? "").includes("localhost");

  const logoStepsArray = [1, 7, 8, 9, 10];

  return (
    <Box
      sx={{
        width: "60%",
        height: "100%",
        "@media (max-width: 600px)": {
          width: "100%",
        },
      }}
    >
      {logoStepsArray.includes(currentStep) && (
        <>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: 2,
              mb: 3,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: 90,
                // borderRadius: "50%",
                overflow: "hidden", // Asegura que la imagen no se salga del contenedor
                //backgroundColor: "#f0f0f0",
              }}
            >
              <img
                alt="Logo"
                src={company ? `${IMAGE_SERVER}/${company.image}` : logoHeader}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain", // Asegura que la imagen ocupe todo el espacio sin deformarse
                }}
              />
            </Box>

          </Box>
        </>
      )}
      {currentStep === 1 && (
        <div>

          <OperationDischarge nextStep={handleNextStep}/>
        </div>
      )}
      {currentStep === 2 && (
        <div>
          <DocumentObverseCapture nextStep={handleNextStep} previousStep={handlePreviousStep}/>
        </div>
      )}
      {currentStep === 3 && (
        <div>
          <DocumentReverseCapture nextStep={handleNextStep} previousStep={handlePreviousStep}/>
        </div>
      )}
      {currentStep === 4 && (
        <div>
          <DocumentVerification nextStep={handleNextStep} previousStep={handlePreviousStep}/>
        </div>
      )}
      {currentStep === 5 && (
        <div>
          <OperationRecomendation
            nextStep={handleNextStep}
            reset={handleReset}
            finalStep={handleFinalStep} 
            previousStep={handlePreviousStep}/>
        </div>
      )}
      {currentStep === 6 && (
        <div>
          <LegalTerms nextStep={handleNextStep} previousStep={handlePreviousStep}/>
        </div>
      )}
      {currentStep === 7 && (
        <div>
          <ProfessionalActivityDropdown nextStep={handleNextStep} previousStep={handlePreviousStep}/>
        </div>
      )}
      {currentStep === 8 && (
        <div>
          <PublicOfficeDropdown nextStep={handleNextStep} previousStep={handlePreviousStep}/>
        </div>
      )}
      {currentStep === 9 && (
        <div>
          <PurchasePurposeDropdown nextStep={handleNextStep} previousStep={handlePreviousStep}/>
        </div>
      )}
      {currentStep === 10 && (
        <div>
          <Signature nextStep={handleNextStep} previousStep={handlePreviousStep}/>
        </div>
      )}
      {currentStep === 11 && (
        <div>
          <ScanDocumentComponent nextStep={handleNextStep} previousStep={handlePreviousStep}/>
        </div>
      )}
      {currentStep === 12 && (
        <div>
          <FinishOperation previousStep={handlePreviousStep}/>
        </div>
      )}
    </Box>
  );
};

export default StepperForm;
